// style-utils.js
import { css } from 'styled-components';

export const media = {
  tinyOnly: (...args) => css`
    @media (max-width: 349px) {
      ${css(...args)};
    }
  `,
  smallPhoneAndUp: (...args) => css`
    @media (min-width: 350px) {
      ${css(...args)};
    }
  `,
  largePhoneAndUp: (...args) => css`
    @media (min-width: 450px) {
      ${css(...args)};
    }
  `,
  phoneOnly: (...args) => css`
    @media (max-width: 599px) {
      ${css(...args)};
    }
  `,
  tabletPortraitAndUp: (...args) => css`
    @media (min-width: 600px) {
      ${css(...args)};
    }
  `,
  tabletLandscapeAndUp: (...args) => css`
    @media (min-width: 900px) {
      ${css(...args)};
    }
  `,
  desktopAndUp: (...args) => css`
    @media (min-width: 1200px) {
      ${css(...args)};
    }
  `,
  mediumDesktopAndUp: (...args) => css`
    @media (min-width: 1400px) {
      ${css(...args)};
    }
  `,
  largeDesktopAndUp: (...args) => css`
    @media (min-width: 1800px) {
      ${css(...args)};
    }
  `,
  hugeDesktopAndUp: (...args) => css`
    @media (min-width: 2400px) {
      ${css(...args)};
    }
  `,
};

export const font = (fontSize, fontWeight, lineHeight, letterSpacing) => css`
  font-size: ${fontSize ? toRem(fontSize) + 'rem' : '1em'};
  font-weight: ${fontWeight ? WEIGHTS[fontWeight] : undefined};
  letter-spacing: ${letterSpacing ? toEm(letterSpacing, fontSize) + 'em' : undefined};
  line-height: ${lineHeight ? toEm(lineHeight, fontSize) + 'em' : undefined};
`;

const toRem = value => value / 10;

const toEm = (value, fontSize) => value / fontSize;

const WEIGHTS = {
  'Extra Light': 100,
  'Ultra Light': 100,
  Light: 200,
  Thin: 200,
  Book: 300,
  Demi: 300,
  Normal: 400,
  Regular: 400,
  Medium: 500,
  Semibold: 600,
  Demibold: 600,
  Bold: 700,
  Black: 800,
  'Extra Bold': 800,
  Heavy: 800,
  'Extra Black': 900,
  Fat: 900,
  Poster: 900,
  'Ultra Black': 900,
};

export const colorStyles = ColorObj => css`
  ${Object.keys(ColorObj).map(
    key => css`
      ${key === 'Default' ? '' : ':' + key + '{'}
        color: ${ColorObj[key].Foreground};
        background-color: ${ColorObj[key].Background};
      ${key === 'Default' ? '' : '}'}
    `
  )}
`;



// WEBPACK FOOTER //
// ./src/components/style-utils.js